(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9111],{

/***/ 79676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ favoritos; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/layouts/user-settings/index.tsx + 1 modules
var user_settings = __webpack_require__(74232);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./api/clients/favorites/favorites.request.ts + 1 modules
var favorites_request = __webpack_require__(16366);
// EXTERNAL MODULE: ./custom-hooks/useGetPersintParamas.hook.ts
var useGetPersintParamas_hook = __webpack_require__(53541);
// EXTERNAL MODULE: ./custom-hooks/useWindowsSize.hook.js
var useWindowsSize_hook = __webpack_require__(51860);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./shared/components/loading-bubbles/index.tsx
var loading_bubbles = __webpack_require__(47364);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
// EXTERNAL MODULE: ./shared/components/property-card/index.tsx + 1 modules
var property_card = __webpack_require__(39470);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HeartBroken.js
var HeartBroken = __webpack_require__(73922);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/favorites-properties/favorites-list-infinite.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















function FavoritesListInfinite() {
  var _infiniteFavorites$pa;

  var t = (0,next_intl_cjs_production_min.useTranslations)("ProfileFavoritesPage");
  var ref = (0,useGetPersintParamas_hook/* default */.Z)();
  var size = (0,useWindowsSize_hook/* default */.Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;

  var request$ = function request$(_ref) {
    var _ref$pageParam = _ref.pageParam,
        pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
    return (0,favorites_request/* getFavorites */._l)({
      page: pageParam
    });
  };

  var _useInfiniteQuery = (0,useInfiniteQuery/* useInfiniteQuery */.N)(["favorites", "infinite"], request$, {
    getNextPageParam: function getNextPageParam(_ref2, pages) {
      var meta = _ref2.meta;

      if (meta.last_page == meta.current_page) {
        return false;
      }

      return pages.length + 1;
    },
    refetchOnWindowFocus: false,
    // Forcing react-query to always reset data with fresh data every time
    cacheTime: 0
  }),
      infiniteFavorites = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading,
      hasNextPage = _useInfiniteQuery.hasNextPage,
      isError = _useInfiniteQuery.isError;

  var getMore = function getMore() {
    if (!isLoading && hasNextPage) {
      fetchNextPage();
    }
  };

  if (isLoading && infiniteFavorites === undefined) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, {
      message: t("loading")
    }));
  }

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: t("error")
    }));
  }

  if (infiniteFavorites && infiniteFavorites.pages[0].data.length === 0) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)(NoFavorites, null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, t("no-favorites"), (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)(HeartBroken/* default */.Z, null))));
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)((react_infinite_scroller_default()), {
    loadMore: getMore,
    hasMore: hasNextPage,
    loader: (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, {
      message: t("loading")
    })
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SearchContentResults, null, infiniteFavorites && ((_infiniteFavorites$pa = infiniteFavorites.pages) === null || _infiniteFavorites$pa === void 0 ? void 0 : _infiniteFavorites$pa.map(function (_ref3) {
    var data = _ref3.data;
    return data.map(function (property, i) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
        key: i,
        href: pages_path/* CPagesPath.es.property_detail */.K.es.property_detail(property) + ref,
        passHref: true
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(CardWrapper, {
        key: i,
        target: width > 991 ? "_blank" : ""
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPropertyCard, property)));
    });
  }))));
}

var StyledPropertyCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(property_card/* default */.Z,  true ? {
  target: "e1ombtcr4"
} : 0)( true ? {
  name: "1wvq27v",
  styles: "@media screen and (max-width: 500px){width:315px;}"
} : 0);

var CardWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1ombtcr3"
} : 0)( true ? {
  name: "1dy7i53",
  styles: "display:flex;justify-content:center;margin:5px"
} : 0);

var SearchContentResults = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ombtcr2"
} : 0)( true ? {
  name: "14bbdzl",
  styles: "display:grid;justify-content:space-between;grid-template-columns:repeat(auto-fill, minmax(270px, 1fr));gap:12px 8px;margin-top:30px"
} : 0);

var SearchResults = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ombtcr1"
} : 0)( true ? {
  name: "xn1cry",
  styles: "display:flex;margin-top:30px;justify-content:center;align-items:center"
} : 0);

var NoFavorites = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ombtcr0"
} : 0)( true ? {
  name: "11kx25k",
  styles: "display:grid;place-content:center;margin-top:30px;text-align:center;span{color:var(--color-brand-blue-main);font-weight:bold;}"
} : 0);
// EXTERNAL MODULE: ./shared/context/show-fav-action-snackbar.context.tsx
var show_fav_action_snackbar_context = __webpack_require__(9094);
;// CONCATENATED MODULE: ./pages/perfil/configuracion/favoritos/index.tsx


function favoritos_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












function FavoritesPage(props) {
  var titleT = (0,next_intl_cjs_production_min.useTranslations)("title-pages");
  var t = (0,next_intl_cjs_production_min.useTranslations)("ProfileFavoritesPage");
  var router = (0,next_router.useRouter)();
  var user = (0,redux_hooks/* useAppSelector */.C)(function (state) {
    return state.Auth.user;
  });
  (0,react.useEffect)(function () {
    if (!user) router.push(pages_path/* CPagesPath.es.signin */.K.es.signin);
  });
  if (!user) return null;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, titleT("profile-favorites"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, (0,emotion_react_browser_esm/* jsx */.tZ)("h1", null, t("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(show_fav_action_snackbar_context/* FavActionMadeFromList.Provider */.s.Provider, {
    value: false
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(FavoritesListInfinite, null))));
}

FavoritesPage.Layout = user_settings/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var favoritos = (FavoritesPage);

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e15qdu5x0"
} : 0)( true ? {
  name: "7c4m5s",
  styles: "display:grid;place-content:center;grid-template-columns:1fr;max-width:var(--list-max-width);margin:auto;padding:30px 20px;h1{color:var(--color-brand-blue-main);}"
} : 0);

/***/ }),

/***/ 52659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MessageResults; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var MessageResults = function MessageResults(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(MessageContent, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", null, props.message, " ", (props === null || props === void 0 ? void 0 : props.modalComponent) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(props.modalComponent, {})));
};

var MessageContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ef5l1rl0"
} : 0)( true ? {
  name: "11ru1eu",
  styles: "height:calc(100vh - 375px);display:flex;justify-content:center;align-items:center;& span{font-size:19px;font-weight:600;color:var(--color-brand-grey-main);max-width:800px;text-align:center;}"
} : 0);

/***/ }),

/***/ 50501:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/favoritos",
      function () {
        return __webpack_require__(79676);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,2615,4022,70,1664,7918,3828,4864,841,2834,6939,5675,5173,9027,780,8654,9470,4671,2888,179], function() { return __webpack_exec__(50501); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);